module.exports = __webpack_public_path__ + "672d124e7814cde941e7ceb81873bffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic9.png
// module id = 1868
// module chunks = 0